// Spec §4.3: UI logic hook for DetailTitleComponent
import { useNavigate } from 'react-router-dom';
import type { DetailTitleComponentProps } from './types';

/**
 * Provides the detail page title header with its back navigation behaviour. Prefers the handleClickBack prop when supplied and otherwise routes to linkGoBack through the router's navigate.
 *
 * @param props - Header props carrying handleClickBack and linkGoBack.
 * @returns The back click handler.
 */
export const useDetailTitleComponent = (props: DetailTitleComponentProps) => {
  const navigate = useNavigate();

  /**
   * Handles the back button on the detail title header. Calls the handleClickBack prop when provided, otherwise navigates to linkGoBack.
   *
   * @returns Nothing.
   */
  const onClickBack = () => {
    if (props.handleClickBack) {
      props.handleClickBack();
    } else if (props.linkGoBack) {
      navigate(props.linkGoBack);
    }
  };

  return { onClickBack };
};
